import type { Lang } from '../../lib/i18n';
import { workoutStrings } from '../../lib/tools';
import { EmbedLayout } from '../../components/tools/ToolParts';
import { WORKOUT_SLUG, WorkoutGenerator } from '../../components/tools/WorkoutGenerator';

export default function WorkoutGeneratorEmbed({ lang = 'en' as Lang }: { lang?: Lang }) {
  const t = workoutStrings(lang);
  return (
    <EmbedLayout lang={lang} slug={WORKOUT_SLUG} title={t.embed.frameTitle} credit={t.embed.credit}>
      <WorkoutGenerator lang={lang} embed />
    </EmbedLayout>
  );
}
